import styled from 'styled-components'

import { MenuItem } from '@ucheba/ui/components/Menu/desktop'
import { Button } from '@ucheba/ui/components/Button/desktop'
import IconMore from '@ucheba/ui/icons/icon__more.svg'
import IconDownRight from '@ucheba/ui/icons/icon__down-right.svg'
import { sv } from '@ucheba/utils/helpers/styles/variables'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`

export const TouchContainer = styled.div`
  display: flex;
  justify-content: space-between;
  column-gap: 8px;
`

export const ActiveItem = styled.div`
  color: ${sv.color.blue};
  display: flex;
  align-items: center;
  margin-top: 8px;
`

export const LogoPlaceholder = styled.div`
  width: 64px;
  height: 80px;
`

export const IconDownRightStyled = styled(IconDownRight)`
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  margin-right: 8px;

  color: ${sv.color.blue};
`

export const IconMoreStyled = styled(IconMore)`
  width: 20px;
  height: 20px;

  color: ${sv.color.gray60};
`

export const ButtonStyledTouch = styled(Button)`
  width: 40px;
  height: 40px;
  margin-left: 4px;
`

export const ButtonStyled = styled(Button)`
  width: 40px;
  height: 40px;
  margin-left: -8px;
`

export const MenuItemStyled = styled(MenuItem)`
  ::after {
    display: none;
  }
`

export const List = styled.ul`
  padding-left: 28px;
  margin: 0;
`
